import {ForYouEventType} from "../../for_you/types/ForYouEventType";
import {hitGoogleTagManager} from "../../tracking/google_tag_manager/hit_google_tag_manager";

interface IHotlineConsultantWidgetEventParams {
    eventCategory: string;
}

interface IHotlineConsultantWidgetClickEventParams extends IHotlineConsultantWidgetEventParams {
    eventLabel: string;
}

export const gtmHotlineConsultantWidgetView = (params: IHotlineConsultantWidgetEventParams) => {
    hitGoogleTagManager({
        event: ForYouEventType.WIDGET,
        event_action: "view",
        event_category: params.eventCategory
    });
};

export const gtmHotlineConsultantWidgetClick = (params: IHotlineConsultantWidgetClickEventParams) => {
    hitGoogleTagManager({
        event: ForYouEventType.WIDGET,
        event_action: "click",
        event_label: params.eventLabel,
        event_category: params.eventCategory
    });
};
import {ForYouEventType} from "../../for_you/types/ForYouEventType";
import {hitGoogleTagManager} from "../../tracking/google_tag_manager/hit_google_tag_manager";

interface IHotlineConsultantWidgetEventParams {
    eventCategory: string;
}

interface IHotlineConsultantWidgetClickEventParams extends IHotlineConsultantWidgetEventParams {
    eventLabel: string;
}

export const gtmHotlineConsultantWidgetView = (params: IHotlineConsultantWidgetEventParams) => {
    hitGoogleTagManager({
        event: ForYouEventType.WIDGET,
        event_action: "view",
        event_category: params.eventCategory
    });
};

export const gtmHotlineConsultantWidgetClick = (params: IHotlineConsultantWidgetClickEventParams) => {
    hitGoogleTagManager({
        event: ForYouEventType.WIDGET,
        event_action: "click",
        event_label: params.eventLabel,
        event_category: params.eventCategory
    });
};
